export const APPROVE_ARTICLES_GET_ARTICLES = 'APPROVE_ARTICLES_GET_ARTICLES';
export const APPROVE_ARTICLES_GET_ARTICLES_SUCCESS = 'APPROVE_ARTICLES_GET_ARTICLES_SUCCESS';
export const APPROVE_ARTICLES_GET_ARTICLES_FAILURE = 'APPROVE_ARTICLES_GET_ARTICLES_FAILURE';

export const APPROVE_ARTICLES_REMOVE_ARTICLES = 'APPROVE_ARTICLES_REMOVE_ARTICLES';
export const APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS = 'APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS';
export const APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE = 'APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE';

export const APPROVE_ARTICLES_PROPS_CHANGED = 'APPROVE_ARTICLES_PROPS_CHANGED';